export interface StarterFormProps {
	id: number;
	genes: StarterFormGeneProps;
	horseName: string;
	horseIsMale: boolean;
	username: string;
	email: string;
	password: string;
	terms: boolean;
	wipe: boolean;
	registrationKey?: string;
}

export interface StarterFormGeneProps {
	base: string;
	dun: boolean;
	cream: boolean;
	grey: boolean;
	tobiano: boolean;
	overo: boolean;
	leopard: boolean;
	marks: {
		head: boolean;
		leg: boolean;
	};
}

export const defaultStarterFormGene = (): StarterFormGeneProps => ({
	base: 'black',
	dun: false,
	cream: false,
	grey: false,
	tobiano: false,
	overo: false,
	leopard: false,
	marks: {
		head: false,
		leg: false,
	},
});

export const defaultStarterForm: StarterFormProps = {
	id: 0,
	genes: defaultStarterFormGene(),
	horseName: '',
	horseIsMale: false,
	username: '',
	email: '',
	password: '',
	terms: false,
	wipe: false,
	registrationKey: '',
};
